module.exports = __webpack_public_path__ + "img/guide_b.4a584b38.svg";